<template>
  <base-dblclick-input
    modelType="contact"
    :model-id="companyContact.id"
    field-name="prefix"
    :field-value="companyContact.prefix"
    inputType="text"
    @refetch="fetchNewCompanies"
  ></base-dblclick-input>
</template>

<script>
  export default {
      name: "company-contact-prefix-cell"
  }

</script>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      companyContact: Object
  })

  const emit = defineEmits(['refetch-companies'])

  function fetchNewCompanies () {
      emit('refetch-companies')
  }
</script>